// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_hx-0";
export var fileCarousel = "_hx-2";
export var removeFileButton = "_hx-1";